import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import {
	Container,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link } from "react-router-dom"
import * as url from "../../../helpers/url_helper"
import {LOOKSEE_API_URL} from "../../../helpers/api_helper";
import $ from "jquery"

class LookseePolicyEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
		type: "",
		weekly_looksee:"",
		daily_looksee: "", 
		monthly_looksee: "",
        _id: ""
    }
  }
  updateItem = (e) => {
    // e.preventDefault();
    console.log(e);
    this.setState({
		weekly_looksee: e.weekly_looksee,
		daily_looksee:  e.daily_looksee, 
		monthly_looksee:  e.monthly_looksee,
        _id: e._id
    })
  }
  	componentDidMount(){
		const { data } = this.props.location
		console.log(data)
		const {type, weekly_looksee, daily_looksee, monthly_looksee, _id } = data;
		this.setState({
			type,
			weekly_looksee, 
			daily_looksee, 
			monthly_looksee,
			_id
		})
	}
	handleValidSubmit = (e) => {
		e.preventDefault();
		const data = this.state;
		const { type, weekly_looksee, daily_looksee, monthly_looksee, _id } = data;
		const BToken = localStorage.getItem("gameAuth");
		const BearerToken = JSON.parse(BToken);

		fetch(`${LOOKSEE_API_URL}${url.PUT_DASHBOARD_LOOKSEE_POLICY_UPDATE}/${_id}`, {
			method: 'put',
			headers: {
				'Authorization': `${BearerToken}`,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				_id,
				weekly_looksee,
				daily_looksee,
				monthly_looksee,
			})
		})
		.then(res => res.json())
		.then(data => {
			const {
				status,
				entity
			} = data ;
			if(status) {
				this.props.history.push("/looksee-config-list")
			}
		})
	}

	handleInputChange = (e) => {
		this.setState({
			[e.target.name] : e.target.value
		})
	}


  render() {
	  const {type, daily_looksee, monthly_looksee, _id } = this.state;
    return (
      <React.Fragment>
		  <div className="page-content">
          <MetaTags>
            <title>Game | AP - Looksee </title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={("Looksee Policy")}
              breadcrumbItem={("Edit Free Usage limits")}
            />
        <Col md={12}>
          <Card>
            <CardBody>
              	<CardTitle className="h4"></CardTitle>				  

				  <Form onSubmit={this.handleValidSubmit}>
						<FormGroup className="row mb-4">
						<Label
							htmlFor="horizontal-daily_looksee-Input"
							className="col-sm-1 col-form-label text-md-right"
							style={{textAlign: "center"}}
						>
							{ type }
						</Label>
						<Col sm={6}>
							<Input
							value={(type === "Daily")?  daily_looksee: monthly_looksee}
							type="number"
							name={(type === "Daily")?  "daily_looksee": "monthly_looksee"}
							className="form-control"
							id="horizontal-daily_looksee-Input"
							onChange={this.handleInputChange}
							
							/>
						</Col>
						</FormGroup>
						
						<FormGroup className="row justify-content-end">
						<Col sm={11}>
							<div>
							<Button
								type="submit"
								color="primary"
								className="w-md"
							>
								Update
							</Button> &nbsp; &nbsp; &nbsp; <span className="loading"></span>
							</div>
						</Col>
						</FormGroup>
					</Form>
            </CardBody>
          </Card>
        </Col>

		</Container>
        </div>
	  </React.Fragment>
    )
  }
}

LookseePolicyEdit.propTypes = {
	t: PropTypes.any
}
export default LookseePolicyEdit
